export const INTERNAL_MESSAGE_ERROR_KEY = '[Internal Message Error]';
export const INTERNAL_MESSAGE_SOURCE = 'pimster-embed-server';
export const INTERNAL_MESSAGE_ALLOWED_SOURCE = 'pimster-embed';
